import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';

@Component({
    selector: 'medpace-logout',
    standalone: true,
    templateUrl: './logout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [],
})
export class MedpaceLogoutComponent {
    constructor(private auth: AuthService) {
        this.logout();
    }

    logout() {
        this.auth.logout();
    }
}
